import React from 'react';

const Footer = () => {
  return (
    <div className='flex justify-end align-center bg-teal-500 p-4 mb-0 text-2xs text-white font-mono'>
      <p>Copyright * 2022 Image Gallery rights reserved.</p>
    </div>
  )
}

export default Footer;

